import alwaysNumber from './alwaysNumber';

/**
 * Formats a numeric value as a comma-separated string (every 3 digits).
 *
 * @example
 * import formatNumber from '@carvana/futilities/formatNumber';
 * formatNumber(100000)
 * // () => '1,000,000'
 * formatNumber(100)
 * // () => '100'
 *
 * @kind function
 * @name formatNumber
 * @sig Number -> String
 * @param {Number} value The numeric value to be formatted
 * @returns {String} The original value formatted as a comma-separated string
 */
function formatNumber(num: number) {
  return String(alwaysNumber(num)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export default formatNumber;
